import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import UserReportPage from "../../KnfSuperAdmin/Report/UserReportPage";
import ConsolidatedReport from "../../KnfSuperAdmin/Report/ConsolidatedReport";
import SelectBox from "../../../components/SelectBox";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";

const CompanyAllReports = () => {
  const location = useLocation();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [reportType, setReportType] = useState("");
  const [reportData, setReportData] = useState({});

  const [cameraList, setCameraList] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selecetdCam, setSelectedCam] = useState(null);

  const getCameraList = () => {
    let formdata = new FormData();
    formdata.append("site_id", location?.state?.data?.id);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCameraList(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCameraList();
  }, []);

  const handlePreview = () => {
    if (!reportType) {
      toast.error("Please Select Report Type");
      return;
    }

    if (!fromDate) {
      toast.error("Please Select From Date");
      return;
    }

    if (!toDate) {
      toast.error("Please Select To Date");
      return;
    }

    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", location?.state?.data?.id);

    if (selecetdCam?.value) {
      formdata.append("camera_id", selecetdCam?.value);
    }

    let url_ = "";

    if (reportType == "user") {
      url_ = URL.GET_USER_REPORT_ADMIN;
    } else {
      url_ = URL.GET_CONSOLIDATED_REPORT_ADMIN;
    }

    post(url_, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleChange = (even) => {
    setReportType(even);
    setReportData({});
  };

  return (
    <div>
      <div className={`d-flex ac-jb`}>
        <div className="col-md-3 mb-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            Report Type
          </h4>
          <select
            name="Report Type"
            value={reportType}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            className="input-pop ps-2 w-100"
            style={{ borderRadius: "10px" }}
          >
            <option value={""}>Select Report Type</option>
            <option value={"user"}>User Report</option>
            <option value={"consolidated"}>Consolidated Report</option>
          </select>
        </div>
        <CommonDatePickerReports
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={(even) => {
            setFromDate(even);
            setReportData({});
          }}
          setToDate={(even) => {
            setToDate(even);
            setReportData({});
          }}
        />
        <div className="col-md-2 mb-4">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(even) => {
              setSelectedCam(even);
              setReportData({});
            }}
            style={true}
          />
        </div>
      </div>
      <div className="d-flex ac-je">
        <div className="col-md-1 mt-4">
          <button
            onClick={handlePreview}
            className="submit-btn"
            // disabled={!fromDate || !toDate}
          >
            Preview
          </button>
        </div>
      </div>
      {reportData?.company && reportType == "consolidated" && (
        <ConsolidatedReport data={reportData} />
      )}
      {reportData?.company && reportType == "user" && (
        <UserReportPage data={reportData} />
      )}
    </div>
  );
};

export default CompanyAllReports;
